/**
 * Vessel Info Section
 * Vessel Name and Voyage Number
 *
 * Note: Booking Number and BL Number are now in ContainerInfoSection
 */

import { Input } from '@/components/base/input/input';
import type { ContainerFormData } from '@/hooks/useContainerForm';
import { useTranslation } from 'react-i18next';

interface VesselBookingSectionProps {
    formData: ContainerFormData;
    onInputChange: (field: keyof ContainerFormData, value: string) => void;
}

export function VesselBookingSection({
    formData,
    onInputChange,
}: VesselBookingSectionProps) {
    const { t } = useTranslation('pages:containers');

    return (
        <div className="rounded-xl bg-primary p-6 shadow-xs ring-1 ring-secondary">
            <h2 className="text-lg font-semibold text-primary mb-6">{t('form.sections.vesselInfo', 'Vessel Information')}</h2>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                <Input
                    label={t('form.fields.vesselName', 'Vessel Name')}
                    placeholder={t('form.fields.vesselNamePlaceholder', 'Enter vessel name')}
                    value={formData.vesselName}
                    onChange={(value) => onInputChange('vesselName', value)}
                    size="md"
                />
                <Input
                    label={t('form.fields.voyageNumber', 'Voyage Number')}
                    placeholder={t('form.fields.voyageNumberPlaceholder', 'Enter voyage number')}
                    value={formData.voyageNumber}
                    onChange={(value) => onInputChange('voyageNumber', value)}
                    size="md"
                />
            </div>
        </div>
    );
}
